export default __webpack_public_path__ + "09ee7572acdfc838195bca0df88f638c.svg";